import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { WorkOrdersEntityEffects } from './work-orders.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([WorkOrdersEntityEffects])]
})
export class WorkOrdersEntityModule {}
